import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
    to?: string;
    label?: string;
    className?: string;
}

export default function BackButton({ to, label = 'Back', className = '' }: BackButtonProps) {
    const navigate = useNavigate();

    const handleBack = () => {
        if (to) {
            navigate(to);
        } else {
            navigate(-1);
        }
    };

    return (
        <button
            onClick={handleBack}
            className={`flex items-center gap-2 text-text-secondary hover:text-text-primary transition-colors ${className}`}
        >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            <span className="font-medium">{label}</span>
        </button>
    );
}
